import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a3ebc71a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3ebc71a')) {
      api.createRecord('a3ebc71a', component.options)
    } else {
      api.reload('a3ebc71a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a3ebc71a&", function () {
      api.rerender('a3ebc71a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/item-tag/index.vue"
export default component.exports